// extracted by mini-css-extract-plugin
export var expandedMailListItemColor = "F7P4e";
export var expandedSelectedHeader = "mGYRE";
export var flaggedMailListItemColor = "iZbPU";
export var pinnedMailListItemColor = "gPZmZ";
export var regularMailListItemColor = "IjQyD";
export var selectedMailListItemColor = "epBmH";